import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Outlet, Link } from "react-router-dom";
import Footer from "./Footer.js";
import ArrowRight from "./ArrowRight.js";
import HoriLine from "./HoriLine.js";
import BlobLeft from "./BlobLeft.js";
import BlobRight from "./BlobRight.js";
import LinearProgress from "@mui/material/LinearProgress";
import { ThemeProvider } from '@mui/material/styles';


function sectionCallbackMob()
{
	/*
	console.log("Play video");
	if (kasittelyVideoCanPlay)
		if (!videoPlaying) document.getElementById("uhkvideoelementforplayback").play();
	window.SECTIONCALLBACKS = [];
	*/
}

function ihs(f)
{
	return (window.innerHeight * f) + "px";
}



function KasittelyMob(p)
{
	window.SECTIONCALLBACKS = [];
	window.SECTIONCALLBACKS.push(sectionCallbackMob);
	return (<div style={{color: "#000000", fontSize: "100%", textAlign: "center"}}>
		<div className="keskitettymob">
		<h1>{window.KASITTELYTEKSTIT.ekaosio}</h1>
		</div>
		<div key="gapihmomia" className="otsikkogap"></div>
		<div className="keskitettymob">
		{window.KASITTELYTEKSTIT.ekaosioekar}
		</div>
		<div key="gapihmomib" className="paragap"></div>
		<div className="keskitettymob">
		{window.KASITTELYTEKSTIT.ekaosiotokar}
		</div>
		<HoriLine fromcolor="rgb(255, 255, 255)" tocolor="rgb(235,225,210)"/>
		<div key="gapihmomic" className="osiogap"></div>
		<div className="keskitettymob">
			<img height={ihs(0.25)} src={window.KASITTELYTEKSTIT.tokaosiokuva} /><br/>
			{window.KASITTELYTEKSTIT.tokaosiokuvateksti}
		</div>
		<div style={{ display: "grid", gridTemplateColumns: "1fr", gridTemplateRows: "repeat(auto-fit, minmax(100px, auto))", justifyItems: "center", alignItems: "center"}}>
			<div style={{display: "inline-block", verticalAlign: "middle", lineHeight:"1"}}>
				<div className="keskitettymob">
				<h3>{window.KASITTELYTEKSTIT.tokaosioekar}</h3>
				</div>
				<div key="gapihmomid" className="osiogap"></div>
				<div className="keskitettymob">{window.KASITTELYTEKSTIT.tokaosiotokar}</div>
			</div>
		</div>
		<div key="gapihmomie" className="osiogap"></div>
		<div className="keskitettymob">
		{window.KASITTELYTEKSTIT.kolmasosio}
		</div>
		<section id="uhkvideosection"></section>
		<div key="gapihmomif" className="osiogap"></div>


		<div style={{position: "absolute", clipPath: "polygon(16% 7%, 16% 100%, 92% 100%, 92% 7%)" }}>
			{p.uhkvideo}
			</div>
			<div style={{position: "absolute"}}>
				<img height="500vh" src={window.KASITTELYTEKSTIT.kolmasosiokuva} />
			</div>
		<div key="gapihmomif" className="osiogap"></div>
		<div key="gapihmomif" className="osiogap"></div>
		<div key="gapihmomif" className="osiogap"></div>
		<div key="gapihmomif" className="osiogap"></div>
		<div key="gapihmomif" className="osiogap"></div>
		<div key="gapihmomif" className="osiogap"></div>
		<div key="gapihmomif" className="osiogap"></div>
		<div key="gapihmomif" className="osiogap"></div>
		<div key="gapihmomif" className="osiogap"></div>
		<div key="gapihmomif" className="osiogap"></div>
		<div key="gapihmomif" className="osiogap"></div>
		<div style={{ display: "grid", gridTemplateColumns: "1fr", gridTemplateRows: "repeat(auto-fit, minmax(100px, auto))", justifyItems: "center", alignItems: "center"}}>
			<div style={{display: "inline-block", verticalAlign: "middle", lineHeight:"1"}}>
				<div>{window.KASITTELYTEKSTIT.kolmasosioekar}</div>
				<div key="gapihmomig" className="osiogap"></div>
				<h3>{window.KASITTELYTEKSTIT.kolmasosiotokar}</h3>
			</div>
		</div>

		<div key="gapihmomihe" className="osiogap"></div>
		<div className="keskitettymob" style={{fontSize:"0.5em"}}>
				{window.KASITTELYTEKSTIT.sivunalateksti}
		</div>


		<div className="seuraavasivumob">
			<div className="seuraavasivuotsikko" style={{transform: "scale(0.5)"}}>
				<Link to="../video" style={{textDecoration: "none", verticalAlign: "middle"}} onClick={moveToVideoMob}>
					<span style={{color: "#000000", fontSize:"2em", fontWeight:"bold", verticalAlign: "middle"}}>VIDEO</span>
				</Link>
			</div>
			<div style={{transform: "scale(0.75)"}}>
				<Link to="../video" style={{textDecoration: "none", verticalAlign: "middle"}} onClick={moveToVideoMob}>
					<ArrowRight  stroke="#000000"/>
				</Link>
			</div>
		</div>
				<div key="gapihmomidsiloppu" className="osiogap"></div>
		<div key="gapihmomidsiloppua" className="osiogap"></div>

	</div>);
}
function moveToVideoMob()
{
	window.SETVIDEO();
	window.drawVideo();
}


export default KasittelyMob;
